const takeDefaultConstants = {
  defaultCourseIds: [
    17143,
    16,
    22,
    4506,
    4317,
    3309,
    5045,
    5787,
    6898,
    7898,
    12179,
    13711,
    1,
    8,
    17003,
    5,
    17076,
    17077,
    17078,
    17079,
    17080,
    17081,
    17082
  ],
  defaultRecommendedCourseIds: [],
  defaultNewCourseIds: [],
  defaultTopSaleCourseIds: [],
  defaultSpecialCourseId: 17298,
  defaultSpecialStartDate: 0,
  defaultSpecialCourseIdSecond: undefined,
  defaultSpecialStartDateSecond: undefined,
  defaultSpecialCourseIdsInSubscription: [],
  defaultSpecialCourseIdsBundle: [],
  defaultSpecialCourseIdForClub: undefined,
  defaultSpecialClubId: undefined,
  defaultPaywallServiceId: undefined
}

export default takeDefaultConstants
